var _circle, _circle2, _g, _g2, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1101_349",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1101_349)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1101_349)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 112,
    height: 92,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 30,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 38,
    width: 18,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 54,
    width: 34,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 62,
    width: 34,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 70,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 78,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 86,
    width: 12,
    height: 4,
    fill: "#ECEDEE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1101_349)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 64,
    height: 92,
    fill: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0055 40.0038C26.2764 40.0038 22.8708 62.1722 22.8708 62.1722C22.8708 66.1192 24.7043 69.5768 28.542 70.4929C31.8302 71.2783 35.9679 72.0063 40.0055 72.0063C44.0432 72.0063 48.1808 71.2783 51.4678 70.4942C55.3067 69.5782 57.1389 66.1192 57.1389 62.1736C57.1402 62.1722 53.7346 40.0038 40.0055 40.0038Z",
    fill: "#45545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0049 68.7674C28.2213 68.7674 18.6699 75.3292 18.6699 82.4831V84.0073C18.6699 85.4807 19.8633 86.6741 21.3368 86.6741H58.673C60.1465 86.6741 61.3399 85.4807 61.3399 84.0073V82.4831C61.3399 75.3292 51.7885 68.7674 40.0049 68.7674Z",
    fill: "#CCAA32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.0048,
    cy: 80.0069,
    r: 1.33344,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6718 72.0063C46.6718 74.5358 42.8981 77.34 40.0046 77.34C37.111 77.34 33.3374 74.5358 33.3374 72.0063C33.3374 68.49 33.3374 62.6255 33.3374 62.6255H46.6718C46.6718 62.6255 46.6718 68.49 46.6718 72.0063Z",
    fill: "#F8CD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0054 38.765C45.2698 38.765 50.6729 39.6891 50.6729 51.7287C50.6729 52.6928 50.6729 59.3773 50.6729 60.4067C50.6729 64.707 44.1404 70.6728 40.0054 70.6728C35.8704 70.6728 29.3379 64.707 29.3379 60.408C29.3379 59.3786 29.3379 52.6941 29.3379 51.73C29.3379 40.0038 34.741 38.765 40.0054 38.765Z",
    fill: "#FFDCB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0056 34.67C33.0877 34.67 32.005 38.6703 32.005 38.6703C29.1927 39.085 22.6709 40.0037 22.6709 61.9761C22.6709 67.0445 25.2084 68.906 26.1378 69.4474C22.6709 50.2939 35.4399 53.3861 33.3384 41.3372C38.7335 57.0891 55.0641 41.4092 54.5014 68.9847C56.1095 67.7619 57.3403 65.3084 57.3403 61.9761C57.3403 43.5667 49.8717 34.67 40.0056 34.67Z",
    fill: "#1A1B1F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 11,
    height: 92,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 70.0004V82.188H32V70C30.5849 70.386 29.2452 70.869 28 71.4335V82.188H23C21.8954 82.188 21 83.0834 21 84.188V86.8328C21.109 86.8463 21.22 86.8533 21.3327 86.8533H58V84.188C58 83.0834 57.1046 82.188 56 82.188H52V71.4341C50.7548 70.8695 49.4152 70.3864 48 70.0004Z",
    fill: "#FFD43E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1101_349",
    x: 65,
    y: 9,
    width: 126,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1101_349"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1101_349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1101_349",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1101_349",
    x: 1,
    y: 9,
    width: 78,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1101_349"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1101_349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1101_349",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.3f13f31505f4a3f656f7d702ed6177e2.svg";
export { ForwardRef as ReactComponent };